import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { Helpers } from 'shared-components/helpers/helpers';
import { useWindowSize } from 'shared-components/utils/hooks/use-window-size';

export const InboxHeader = ({
  status: {
    heading,
    mobileHeading,
    content,
    nextSteps,
    additionalContent,
    buttons,
    borderColor
  },
  backBtn,
  forwardBtn,
  responsiveView,
  isMessageDetailsPage
}) => {
  const style = {
    width: !responsiveView ? '100%' : ''
  };

  const windowDims = useWindowSize();
  const applyGrid = windowDims?.width < 992 || isMessageDetailsPage;

  return (
    <div className='main-header-container'>
      <div
        className={classNames('header-nav-container', {
          'ps-container-lg-margin ps-container-fixed': applyGrid
        })}
        style={{
          borderColor: Helpers.pickColor(borderColor)
        }}
      >
        <div
          className={classNames({
            'ps-row': applyGrid
          })}
        >
          <div
            className={classNames({
              'col-xs-12': applyGrid
            })}
            data-testing-id='back-button'
          >
            {backBtn && (
              <Link to={backBtn.to}>
                <i className='ico ico-sm icon-back'></i> {backBtn.title}
              </Link>
            )}
          </div>
        </div>
      </div>
      <div
        className={classNames('header-container', {
          'ps-container-lg-margin ps-container-fixed': applyGrid
        })}
      >
        <div
          className={classNames({
            'ps-row': applyGrid
          })}
        >
          <div
            className={classNames({
              'col-xs-12': applyGrid
            })}
          >
            <div className="heading-nav flex middle space-between">
              <span className="v-center" style={style}>
                <h3 className="d-xs-none d-lg-block" data-testing-id="heading">
                  {heading}
                </h3>
                <h4 className="d-lg-none" data-testing-id="mobile-heading">
                  {responsiveView ? mobileHeading : heading}
                </h4>
              </span>
              {forwardBtn ? (
                <span
                  className="text-right v-center d-lg-none"
                  data-testing-id="forward-button"
                >
                  <Link to={forwardBtn.to}>
                    <div className="flex middle">
                      <span className="margin-sm-right">
                        {forwardBtn.title}
                      </span>
                      <i className="ico ico-sm icon-back"></i>
                    </div>
                  </Link>
                </span>
              ) : (
                ''
              )}
            </div>
            <div
              className={responsiveView ? 'd-xs-none d-lg-block' : ''}
              data-testing-id="content"
            >
              {content}
            </div>
            {(isMessageDetailsPage && nextSteps) && (
              <div
                data-testing-id="next-steps"
              >
                {nextSteps}
              </div>
            )}
            {additionalContent ? (
              <div
                className={responsiveView ? 'd-xs-none d-lg-block' : ''}
                style={{ marginTop: '16px' }}
                data-testing-id='additional-content'
              >
                <p>{additionalContent}</p>
              </div>
            ) : null}
            <ul
              className={`list-inline btn-container ${
                responsiveView ? 'd-xs-none d-lg-block' : ''
              }`}
              data-testing-id='buttons'
            >
              {buttons}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

InboxHeader.propTypes = {
  status: PropTypes.object,
  backBtn: PropTypes.object,
  forwardBtn: PropTypes.object,
  responsiveView: PropTypes.bool
};
